export default "__VITE_ASSET__145a1d00__"